var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillAnalysisIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7207 3.70796H23.4847V1.23596H21.0127V3.70796H8.65266V1.23596H6.18066V3.70796H4.94466C3.58506 3.70796 2.47266 4.82036 2.47266 6.17996V25.956C2.47266 27.3156 3.58506 28.428 4.94466 28.428H24.7207C26.0803 28.428 27.1927 27.3156 27.1927 25.956V6.17996C27.1927 4.82036 26.0803 3.70796 24.7207 3.70796ZM24.7207 25.956H4.94466V12.36H24.7207V25.956ZM24.7207 9.88796H4.94466V6.17996H24.7207V9.88796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillAnalysisIconLight);
export default __webpack_public_path__ + "static/media/SkillAnalysisIconLight.08eedb0550241cb803939d7e7337e347.svg";
export { ForwardRef as ReactComponent };